<div class="bg-gradient-to-br from-white to-violet-50 flex flex-col items-center justify-center h-screen w-full min-w-full min-h-screen px-6 py-12 lg:px-8 overflow-y-auto">

  <div class="sm:mx-auto sm:w-full sm:max-w-sm">
    <img class="mx-auto h-12 w-auto" src="/assets/images/logo_horizontal.png" alt="SalesOMMO">
    <h2 class="mt-10 text-center text-2xl font-bold leading-9 text-gray-900">Recover your password</h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
    <form class="space-y-6" [formGroup]="form" (submit)="processRecover()" method="POST">
      <div>
        <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
        <div class="mt-2">
          <input id="email" formControlName="email" type="email" autocomplete="email" required class="input input-auth">
        </div>
      </div>



      <div>
        <button type="submit" class="btn btn-auth w-full">Send password reset link</button>
      </div>
    </form>

    <p class="mt-10 text-center text-sm/6 font-medium tracking-wide text-gray-500">
      Know your password?
      <a routerLink="/login" class="pointer font-semibold leading-6 text-auth">Login</a>
    </p>
  </div>
</div>
